<template lang="pug">
.v-panel.panel
	.panel__btn(@click="open = true")
		slot(name="btn")
	teleport(to="body")
		transition(name="overlay")
			.panel__overlay(v-if="open" @click="open = false")
		transition(v-if="showMode" :name="isTablet ? 'panel' : 'filter'" @after-enter="handlerAfterEnter")
			.panel__body(v-show="open" :class="bodyClass")
				button.panel__close-btn(type="button" @click="open = false")
					span.panel__close-btn-text(v-if="closeText") {{closeText}}
					v-svg-icon.panel__close-btn-icon(icon="cross-sm")
				.panel__content(ref="content" :class="[isTablet ? '' : 'scrollbar']")
					slot(name="content")
		transition(v-else="" :name="isTablet ? 'panel' : 'filter'" @after-enter="handlerAfterEnter")
			.panel__body(v-if="open" :class="bodyClass")
				button.panel__close-btn(type="button" @click="open = false")
					span.panel__close-btn-text(v-if="closeText") {{closeText}}
					v-svg-icon.panel__close-btn-icon(icon="cross-sm")
				.panel__content(ref="content" :class="[isTablet ? '' : 'scrollbar']")
					slot(name="content")
</template>

<script>

import scrollLock from "scroll-lock";
import {nextTick} from "vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		isMobMixin
	],

	emits: [
		'close',
		'transitionend'
	],

	props: {
		closeText: {
			type: String,
			default: null
		},

		openState: {
			type: Boolean,
			default: false
		},

		bodyClass: {
			type: String,
			default: null
		},

		showMode: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			open: false
		}
	},

	watch: {
		openState(state) {
			this.open = state;
		},

		async open(state) {
			if (state) {
				await nextTick();
				scrollLock.disablePageScroll(this.$refs.content);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.content);
					this.$emit('close');
				}, 300);
			}
		}
	},

	methods: {
		handlerAfterEnter() {
			this.$emit('transitionend');
		}
	}
}

</script>